import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import * as Sentry from "@sentry/react";
import { registerPushServiceWorkerEarly } from "@/lib/pushNotifications";
import { initPwaInstallCapture } from "@/lib/pwaInstallCapture";
import { applyAppViewportHeight } from "@/hooks/useAppViewportHeight";
import { applyDeviceTierToDocument, refineDeviceTierFromHints } from "@/lib/deviceTier";

initPwaInstallCapture();
applyAppViewportHeight();
applyDeviceTierToDocument();
refineDeviceTierFromHints();

// בפיתוח: SW ל-Push (sw-offline-dev.js) — לא מוחקים אותו; SW של Vite PWA dev לא נרשם
if (import.meta.env.DEV && typeof navigator !== "undefined" && "serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations?.().then((regs) => {
    regs.forEach((r) => {
      const url = r.active?.scriptURL || r.installing?.scriptURL || "";
      if (!url.includes("sw-offline-dev.js")) {
        r.unregister();
      }
    });
  });
  registerPushServiceWorkerEarly();
}

// בפרודקשן: רישום PWA + ריענון אוטומטי כשמתגלה גרסה חדשה
if (!import.meta.env.DEV && typeof window !== 'undefined') {
  import('virtual:pwa-register').then(({ registerSW }) => {
    import('@/lib/appUpdate').then(({ registerServiceWorkerUpdates }) => {
      registerServiceWorkerUpdates(registerSW);
    });
  });
}

// בפיתוח לא מריצים Sentry — Session Replay + tracing ב־100% תוקעים מסופון/מובייל חלש
if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://1476123988d68e8f5ba1ab1dd5d30658@o4510872356913152.ingest.us.sentry.io/4510872363008000",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.05,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}


ReactDOM.createRoot(document.getElementById('root')).render(
    <App />
)